import type { Special } from '@/api/endpoints/bars';
import { groupHappyHours } from '../utils/happyHourUtils';
import { HappyHourExpander } from './HappyHourExpander';

interface HappyHoursSectionProps {
  specials: Special[];
  selectedDate: string;
}

export function HappyHoursSection({ specials, selectedDate }: HappyHoursSectionProps) {
  const happyHourGroups = groupHappyHours(specials, selectedDate);

  if (happyHourGroups.length === 0) {
    return null;
  }

  // If only one group, default it to expanded
  const defaultExpandFirst = happyHourGroups.length === 1;

  return (
    <div>
      <h2 className="text-lg font-semibold mb-3">Happy Hours</h2>
      <div className="space-y-2">
        {happyHourGroups.map((group, index) => (
          <HappyHourExpander
            key={group.timeKey}
            displayTime={group.displayTime}
            specials={group.specials}
            defaultExpanded={defaultExpandFirst && index === 0}
          />
        ))}
      </div>
    </div>
  );
}
